module.exports = __webpack_public_path__ + "media/icons/Triangle-824843f5.svg";